/* =========================================================================
   Arch banner swatches — click a dot, swap the banner image.

   Contract, per [Arch Main] Banner section that has swatch blocks:
     .arch-bsw[role=radiogroup]            ← the row, holds the dots
       .arch-bsw__item[role=radio]         ← one per swatch, carries the URLs:
            data-bsw-d-src / data-bsw-d-srcset   (desktop image)
            data-bsw-m-src / data-bsw-m-srcset   (mobile image)
            data-bsw-label
     .arch-bsw__caption                    ← optional, shows the selected name

   It rewrites the section's EXISTING desktop/mobile <img> tags rather than adding
   its own, so the first paint (and the LCP image) is untouched Liquid output.

   Vanilla + plain deferred on purpose: global-arch.js is jQuery-driven and jQuery
   is not loaded in the theme editor, so the theme's own data-block-image image
   swapper is dead in the customiser. This works in both.
   ========================================================================= */
(function () {
  function imgsFor(group) {
    // The two <img> the theme renders — one shown per breakpoint via CSS.
    var control = group.closest('.image-container-control');
    if (!control) return null;
    return {
      desktop: control.querySelector('.image-container img.desktop'),
      mobile: control.querySelector('.image-container img.mobile')
    };
  }

  function apply(img, src, srcset) {
    if (!img || !src) return;
    // srcset must be cleared/replaced first: a stale srcset outranks src, so
    // setting src alone would leave the old image on screen.
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.setAttribute('data-srcset', srcset); // keep lazysizes' copy in step
    } else {
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
    }
    img.setAttribute('src', src);

    img.classList.add('arch-bsw-swapping');
    var done = function () { img.classList.remove('arch-bsw-swapping'); };
    if (img.decode) { img.decode().then(done).catch(done); }
    else { img.addEventListener('load', done, { once: true }); setTimeout(done, 400); }
  }

  function select(group, item, focus) {
    var items = group.__bswItems;
    var imgs = imgsFor(group);

    items.forEach(function (el) {
      var on = el === item;
      el.setAttribute('aria-checked', on ? 'true' : 'false');
      // Roving tabindex: one stop for the whole group, not one per swatch.
      el.setAttribute('tabindex', on ? '0' : '-1');
      el.classList.toggle('is-active', on);
    });

    if (imgs) {
      apply(imgs.desktop, item.getAttribute('data-bsw-d-src'), item.getAttribute('data-bsw-d-srcset'));
      apply(imgs.mobile, item.getAttribute('data-bsw-m-src'), item.getAttribute('data-bsw-m-srcset'));
    }

    var cap = group.__bswCaption;
    if (cap) cap.textContent = item.getAttribute('data-bsw-label') || '';

    if (focus) item.focus();
  }

  function init(group) {
    if (group.dataset.bswInit === '1') return;

    var items = Array.prototype.slice.call(group.querySelectorAll('.arch-bsw__item'));
    if (!items.length) return;

    group.__bswItems = items;
    group.__bswCaption = (group.closest('.image-container-control') || document)
      .querySelector('.arch-bsw__caption');
    group.dataset.bswInit = '1';

    items.forEach(function (item, i) {
      item.addEventListener('click', function () { select(group, item, false); });

      // Radiogroup keyboard behaviour (WCAG 2.1.1): arrows move AND select.
      item.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = items[(i + 1) % items.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = items[(i - 1 + items.length) % items.length];
        else if (e.key === 'Home') next = items[0];
        else if (e.key === 'End') next = items[items.length - 1];
        if (next) { e.preventDefault(); select(group, next, true); }
      });
    });

    // Warm the cache on first approach so the swap feels instant, without
    // costing 4 extra image downloads on initial page load / LCP.
    var warmed = false;
    var warm = function () {
      if (warmed) return;
      warmed = true;
      items.forEach(function (item) {
        ['data-bsw-d-src', 'data-bsw-m-src'].forEach(function (a) {
          var u = item.getAttribute(a);
          if (u) { var im = new Image(); im.src = u; }
        });
      });
    };
    group.addEventListener('pointerenter', warm);
    group.addEventListener('focusin', warm);
    group.addEventListener('touchstart', warm, { passive: true });
  }

  function scan(scope) {
    var groups = (scope || document).querySelectorAll('.arch-bsw[role="radiogroup"]');
    for (var i = 0; i < groups.length; i++) init(groups[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Theme editor replaces the section's DOM on every settings change, taking the
  // init flag with it — re-scan the replacement.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    scan(e.target);
    // Selecting a swatch block in the editor should preview that swatch.
    var item = e.target && e.target.querySelector
      ? (e.target.matches('.arch-bsw__item') ? e.target : e.target.querySelector('.arch-bsw__item'))
      : null;
    if (item) {
      var group = item.closest('.arch-bsw');
      if (group && group.__bswItems) select(group, item, false);
    }
  });
})();
